<template>
<div>
    <transition name="slide-fade">
    <div 
        v-show="its_open" 
        class="flex-column mb-0 pb-0 bg-light justify-content-between" 
        id="chat-box" 
        :class="[`${embedded===true? 'embedded d-flex':'floated bordered'}`, `${its_open===true? 'd-flex':''}`]"
    >
        <header 
            class="row-fluid p-2 text-secondary bg-primary" 
            :class="[`${embedded===true? '':'bordered'}`, `${its_open===true? 'd-flex':''}`]"
        >
            <b-col cols="2" v-if="!embedded">
                <b-img class="logo" rounded="circle" :src="require('@/assets/'+logo)"></b-img>
            </b-col>
            <b-col cols="[`${embedded===true? '12':'9'}`]" class="mx-auto my-auto text-left">
                <h3>{{this.title}} <br><small class="text-white">{{this.subTitle}}</small></h3>
            </b-col>
            <b-col v-if="!embedded" cols="1" class="my-auto mx-auto">
                <b-icon icon="x" font-scale="1.5" @click="its_open = false"></b-icon>
            </b-col> 
        </header>
        <div class="chat-area" style="overflow-y: auto">
            <p 
                v-for="message in messages" 
                v-bind:key="message.id" 
                class="message" 
                v-html="'<span class=text-primary>'+(message.sent_by?message.sent_by:'Tú')+'... </span>'+message.message"
                v-linkified
                :class="{ 'message-out': !message.sent_by, 'message-in': message.sent_by }">
                
            </p>
        </div>
        <div class="p-0">
            <b-form id="my-message-form" class="border-top">
                <fieldset :disabled="sending">
                    <b-input-group class="mt-2 mb-2">
                        <b-form-textarea 
                            v-model="message_text" 
                            id="my-message-input" 
                            ref="message_input"
                            rows="2"
                            max-rows="2"
                            no-resize
                            @keypress.enter.prevent 
                            @keyup.enter="sendMessage"
                            placeholder="Ingrese su pregunta"
                            autofocus></b-form-textarea>
                        <b-input-group-append>
                            <b-button 
                                @click="sendMessage" 
                                size="sm" 
                                variant="primary">
                                <b-icon icon="chevron-double-right" variant="secondary" font-scale="1" ></b-icon>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <small v-if="sending" class="text-success">Enviando.......</small>
                </fieldset>
            </b-form>
        </div>
    </div>
    </transition>
    <transition name="slide-fade">
    <div v-show="!its_open && !embedded && icon" class="chat-icon bg-transparent">
        <b-icon :icon="icon" :variant="icon_variant" :font-scale="icon_font_scale" class="p-0 mr-3 mb-3" @click="its_open = !its_open"></b-icon>
    </div>
    </transition>
</div>
</template>

<script>
    import Vue from 'vue'
    import linkify from 'vue-linkify'

    Vue.directive('linkified', linkify)

    export default Vue.extend({
        name: 'ChatBox',
        props: {
            sent_by: { type: String, default: null },
            assistant: { type: Object, default: () => ({}) },
            title: { type: String, default: "Pregunta al Ponente" },
            subTitle: { type: String, default: "Envíanos tu pregunta..." },
            logo: { type: String, default: "img/logo-web-video-mini.png" },
            icon : { type: String, default: null },  //null => no float icon show
            icon_variant : { type: String, default: "secondary" }, 
            icon_font_scale : { type: Number, default: 2 },
            embedded: { type: Boolean, default: false},
            room : { type: String, default: null }
        },
        updated () {
            document.querySelector('.chat-area').scrollTop = 10000000; // eslint-disable-line
            document.getElementById('my-message-input').focus()
        },
        computed: {
        },
        data() {
            return {
                sending: false,
                its_open: false,
                bobMessage: '',
                message_text: '',
                messages: [],
                thing: {
                    id : null,
                    created_at : null,
                    updated_at : null,
                    attended : null,
                    sent_by : null,
                    assistant_name : null,
                    assistant_email : null,
                    last_status : null,
                    message : null,
                    assistant : null,
                    grupo : null,
                    room : null,
                    assistant_id: this.assistant.id,
                    assistant : {
                        id : null,
                        key_id : null,
                        email : null,
                        name : null,
                        last_name : null,
                        mother_last_name : null,
                        city : null,
                        federal_entity : null,
                        country : null,
                        company : null,
                    }
                },
                beep: null,
            }
        },
        components: {
        },
        methods: {
            showChat() {
                this.its_open = true
            },
            addToChat(message) {
                try {
                    if(!this.messages.some(data => data.id === message.id)){
                        this.messages.push(message)
                    }
                } catch (error) {
                    console.log(error)
                }
                
                this.its_open = true 
                this.beep.play()
            },
            sendMessage() {
                if (!this.message_text) {
                    return
                }
                this.thing.message = this.message_text
                
                this.sending = true
                let url = '/messages'
                let method = 'post'
                if(this.sent_by) this.thing.sent_by = this.sent_by
                
                if(this.room) this.thing.room = this.room
                this.$store.dispatch(method, {'url':url, data: this.thing, headers:{}})
                    .then((resp) => {
                        this.$nextTick(() => {
                            if(!this.messages.some(data => data.id === this.thing.id)){
                                this.messages.push(resp.data)
                            }
                            let messageDisplay = this.$refs.chatArea
                            try {
                                messageDisplay.scrollTop = messageDisplay.scrollHeight
                            } catch (error) {
                                
                            }
                        })
                        this.message_text = ''
                        this.sending = false
                        //this.$refs.message_input.focus()
                    })
                    .catch(err => {
                        this.sending = false
                        if(err.error && (err.error.search("encontrado") > 0)) this.registered = false
                    })
            },
            loadChat() {
                let url = '/messages/mine'
                let method = 'post'
                this.$store.dispatch(method, {'url':url, data: {key_id: this.assistant.key_id}, headers:{}})
                .then((resp) => {
                    let data = this.messages = resp.data
                })
                .catch(err => {
                    if(err.error) alert(err.error)
                })
            },
        },
        watch: {
            its_open(newValue, oldValue) {
                this.$store.commit('set_chat_its_open', newValue)
            }
        },
        mounted () {
            this.beep = new Audio(require('@/assets/beep-08b.mp3'))
            this.loadChat()
        },
        created () {
            this.$eventHub.$on('addToChatMessage', this.addToChat);
            this.$eventHub.$on('showChat', this.showChat);
        },
    })
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,700,700i|Raleway:300,400,500,700,800');
    $font-family-base: "Open Sans", "Raleway" !default;
    $border-radius : 10px;
    $font-size-initial: 16px;
    $font-size-base: 1rem !default;

    .chat-icon {
        position: fixed;
        right:0;
        bottom: 0px;
        color:#ffffff;
        margin: 0px 0px 0px 0px;
        font-family: $font-family-base !important;
    }

    #chat-box {
        color:#ffffff;
        margin: 0px 2px 2px 0px;
        
        font-family: $font-family-base !important;
        
    }

    #chat-box.bordered {
        border-radius: $border-radius;
        border: solid 1px;
        box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.3)
    }

    .embedded {
        width: 100%;
        position: absolute;
        max-height: 100%;
        min-height: 40vh;
        max-height: 100%;
    }

    .floated {
        height: 50vh;
        width: 290px;
        position: fixed;
        right:5px;
        bottom: 5px;
    }

    header {
        height: 58px;
        padding: 10px;
        display: flex;
        flex-direction: row;

        .bordered {
            border-top-left-radius: $border-radius;
            border-top-right-radius: $border-radius;
        }

        img.logo {
            height: 40px !important;
            margin-left:-7px !important;
        }

        h3 {
            font-size: 1.02rem !important;
            line-height: 1rem !important;

            small {
                font-size: .7rem !important;
            }
        }
    }

    .chat-area {
        /*   border: 1px solid #ccc; */
        background: white;
        padding: 0.5em;
        overflow: auto;
        margin: 0 auto 0.2em auto;
        width: 100%;
        height: 100%;
    }

    .message {
        width: 65%;
        border-radius: 10px;
        padding: .5em;
        font-size: .8em;
    }
    .message-out {
        background: #b6cdd5;
        color: black;
        margin-left: 35%;
    }
    .message-in {
        background: #F1F0F0;
        color: black;
    }

    #my-message-form {
        .input-group > .form-control {
            font-size: small;
        }
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: .5;
    }

</style>